import { createRoute, Navigate } from '@tanstack/react-router';
import { Route as parent } from './signed-in.tsx';
export const Route = createRoute({
  getParentRoute: () => parent,
  path: '/chats',
  component: () => <Navigate to="/" search={true} replace />,
});
